// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminRequests = (client) => ({
    /**
     * `GET /admin/requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListRequests
     * @source packages/modules/requests/src/api/admin/requests/route.ts
     */
    list: (query, headers) => client.fetch("/admin/requests", { method: "GET", query, headers }),
    /**
     * `GET /admin/requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetRequestById
     * @source packages/modules/requests/src/api/admin/requests/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/requests/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminReviewRequestById
     * @source packages/modules/requests/src/api/admin/requests/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/requests/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=requests.js.map